import {SET_USER, SET_AUTHENTICATED, SET_UNAUTHENTICATED, LOADING_USER, 
    LOGIN_MAIL,USE_TRUE,USE_FALSE,USER_FILTER_DATA , LOGIN_LOADER,LOGIN_LOADER_OFF} from '../type';
  
const initialState = {
    authenticated: false,
    loading: false,
    credentials: {},
    Passcode: [],
    overlay:false,  
    loginLoader:false,
    userData:{},
}
export default function (state = initialState, action) {
    switch (action.type) {
        case SET_AUTHENTICATED:
            return {
                ...state,
                authenticated: true,
                loading: false,
            };
        case LOGIN_MAIL:
            return {
                ...state,
                Passcode: action.payload,
                loading: false
            }
            case USE_TRUE:
            return {
                ...state,
                overlay: true,
            }
            
            case USE_FALSE:
            return {
                ...state,
                overlay: false,
            }
        case SET_UNAUTHENTICATED:
            return initialState;
        case SET_USER:
            return {
                authenticated: true,
                loading: false,  
                ...action.payload
            }
           
            case USER_FILTER_DATA:
                return {
                    ...state,
                    userData: action.payload,
                    loading: false
                }
                case LOGIN_LOADER:
                    return {
                        ...state,
                        loginLoader: true,  
                        ...action.payload
                    }
                    case LOGIN_LOADER_OFF:
                    return {
                        ...state,
                        loginLoader: false,  
                        ...action.payload
                    }
        default:
            return state;
    }
}